import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash'
import DetailVisibleProvider from 'context/dash/DetailVisible'
import ShowAllEventsProvider from 'context/dash/ShowAllEvents'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import Orders from 'modules/dashboard/orders/Orders'

export default function DashOrders() {
    return (
        <BackButtonCollapseDashProvider>
            <ShowAllEventsProvider>
                <DetailVisibleProvider>

                    <DashContainer title={'Pedidos'}>
                        <Orders />
                    </DashContainer>

                </DetailVisibleProvider>
            </ShowAllEventsProvider>
        </BackButtonCollapseDashProvider>
    )
}
